export const BASE_URL = "https://nadeen11api.onrender.com";
/**
 * https://nadeen11api.onrender.com
 */
